module.exports = __webpack_public_path__ + "img/33.f37cc612.svg";